import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PremiumVisualsHero from "./sections/PremiumVisualsHero";
import TheJunkDaddyDifference from "./sections/TheJunkDaddyDifference";
import FromOurKitchenToYourTable from "./sections/FromOurKitchenToYourTable";
import JelajahiBerdasarkanWilayah from "./sections/JelajahiBerdasarkanWilayah";
import CommonQuestions from "./sections/CommonQuestions";
import JoinTheMovement from "./sections/JoinTheMovement";
import PricingList from "./sections/PricingList";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PremiumVisualsHero />
      <TheJunkDaddyDifference />
      <FromOurKitchenToYourTable />
      <JelajahiBerdasarkanWilayah />
      <PricingList />
      <CommonQuestions />
      <JoinTheMovement />
      <Footer />
    </div>;
}